import { Link } from "react-router-dom";
import styled from "styled-components";
import { hamburgerStore } from "../../state/ui/hamburger_state";
import { riseIn } from "../../style/styled-components/keyframes/fade";
import { menucontext } from "../../context/nav/menucontext";
import { useState } from "react";
import { languageStore } from "../../state/language";
import LanguageSelection from "../contents/LanguageSelection";
const Hamburger = () => {
  const [selectedKey, setSelectedKey] = useState("");
  const hamburger = hamburgerStore();
  const { language } = languageStore();
  const t = (x) => (language === "EN" && x.engtitle ? x.engtitle : x.title);
  const item = (x) => (
    <Link key={x.key} to={x.url} onClick={() => hamburger.close()}>
      {t(x)}
    </Link>
  );
  return (
    <Div>
      <TopBar>
        <LanguageSelection />
        <div>
          <Link to="/careers" onClick={() => hamburger.close()}>
            {language === "EN" ? "Careers" : "채용"}
          </Link>
          {/* <a href="https://a1tcms.com" target="_blank" rel="noreferrer">
            A1 TCMS ↗
          </a> */}
        </div>
      </TopBar>
      <ul>
        {menucontext?.children?.map((x) => {
          const selected = selectedKey === x.key;
          return (
            <Section key={x.key} $selected={selected}>
              <button
                type="button"
                aria-expanded={selected}
                onClick={() => setSelectedKey((prev) => (prev === x.key ? "" : x.key))}
              >
                <span>{t(x)}</span>
                <i aria-hidden="true" />
              </button>
              {selected && (
                <div className="children">
                  {x.children?.map((y) =>
                    y.children ? (
                      <div key={y.key} className="group">
                        <span>{t(y)}</span>
                        {y.children.map(item)}
                      </div>
                    ) : (
                      item(y)
                    )
                  )}
                </div>
              )}
            </Section>
          );
        })}
      </ul>
    </Div>
  );
};
export default Hamburger;
const Div = styled.div`
  position: fixed;
  top: ${({ theme }) => theme.layout.header};
  left: 0;
  right: 0;
  bottom: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
  background-color: white;
  animation: ${riseIn} 0.25s ease-out;
  & > ul {
    padding: 0 1.25rem 3rem;
    margin: 0;
    list-style: none;
  }
`;
const TopBar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.25rem;
  background-color: ${({ theme }) => theme.colors.monotone.extralight};
  border-bottom: 1px solid ${({ theme }) => theme.colors.line};
  & > div {
    display: flex;
    gap: 1.25rem;
    font-size: 0.95rem;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.dark};
  }
`;
const Section = styled.li`
  border-bottom: 1px solid ${({ theme }) => theme.colors.line};
  & > button {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1.15rem 0;
    border: 0;
    background: none;
    cursor: pointer;
    font-size: 1.15rem;
    font-weight: 700;
    color: ${({ $selected, theme }) => ($selected ? theme.colors.accent : theme.colors.foreground.normal)};
    & > i {
      width: 0.55rem;
      height: 0.55rem;
      border-right: 2px solid currentColor;
      border-bottom: 2px solid currentColor;
      transform: rotate(${({ $selected }) => ($selected ? "-135deg" : "45deg")});
      transition: transform 0.2s;
      margin-right: 0.25rem;
    }
  }
  & > .children {
    display: flex;
    flex-direction: column;
    padding: 0 0 1.25rem;
    animation: ${riseIn} 0.2s ease-out;
    & > a,
    & > .group > a {
      padding: 0.6rem 0.75rem;
      border-radius: 0.5rem;
      color: ${({ theme }) => theme.colors.monotone.dark};
      &:active {
        background-color: ${({ theme }) => theme.colors.accentSoft};
      }
    }
    & > .group {
      display: flex;
      flex-direction: column;
      padding-bottom: 0.5rem;
      & > span {
        padding: 0.75rem 0.75rem 0.35rem;
        font-size: 0.8rem;
        font-weight: 700;
        color: ${({ theme }) => theme.colors.accent};
      }
    }
  }
`;
